import { useState, useEffect } from 'react';

// 抽象的自定義 Hook
const useFetchDropdownOptions = ({
  apiUrl, // API 路徑
  optionKey = 'value', // 結構中 key 的名稱
  labelKey = 'label', // 結構中 label 的名稱
  dataKey = 'data', // 從 API 回應中提取資料的 key
  defaultOptionsName = 'Options', // 狀態命名：options
  defaultSelectedName = 'Selected', // 狀態命名：selected
  transformItem, // 傳入的函數，用來定義如何轉換每個 item
}) => {
  // 狀態初始化
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        console.log("執行 useFetchDropdownOptions fetchOptions");
        const response = await fetch(apiUrl);
        const data = await response.json();

        // // 使用動態 dataKey 提取資料 (如 data.client_en)
        // if (data[dataKey]) {
        //   const transformedOptions = data[dataKey].map(transformItem);
        //   console.log("transformedOptions:",transformedOptions);
        //   setOptions(transformedOptions);
        // }

        let rawOptions = [];

        if (dataKey && data[dataKey]) {
          rawOptions = data[dataKey];
        } else if (Array.isArray(data)) {
          rawOptions = data; // 直接是 array，不需要 dataKey
        } else {
          console.error("⚠️ 無法從 API 回應中擷取選項資料：", data);
          return;
        }

        const transformedOptions = rawOptions.map(transformItem);
        console.log("transformedOptions:",transformedOptions);
        setOptions(transformedOptions);
      } catch (error) {
        console.error(`Error fetching ${defaultOptionsName}:`, error);
      }
    };

    fetchOptions();
  }, []);

  const handleOptionChange = (value) => {
    // setSelectedOption(value);
    
    // 確保選中值是字串（如果傳的是物件就取 value 屬性）
    setSelectedOption(typeof value === 'object' ? value?.value : value);
  };

  // 返回動態命名的狀態和方法
  return {
    [`${defaultOptionsName}`]: options,
    [`set${defaultOptionsName}`]: setOptions,
    [`${defaultSelectedName}`]: selectedOption,
    [`set${defaultSelectedName}`]: setSelectedOption,
    // fetchOptions: options,
    handleOptionChange,
  };
};

export default useFetchDropdownOptions;
